import { UnsplashImagesComponent } from './components/unsplash-images/unsplash-images.component';
import { MyImagesComponent } from './components/my-images/my-images.component';
import { ListImagesComponent } from './components/list-images/list-images.component';
import { ImageLibComponent } from './components/image-lib/image-lib.component';
import { EwMaImageService } from './ew-ma-image.service';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { EwMaImageComponent } from './ew-ma-image.component';
import { CommonModule } from '@angular/common';
import { EwMaterialComponentsModule, EwCommonModule } from 'ew-common-lib';
import { NgxPaginationModule } from 'ngx-pagination';
import { TranslateModule, TranslateStore } from '@ngx-translate/core';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { BrowserModule } from '@angular/platform-browser';
import { EwTranslateService } from './services/ew-translate.service';

@NgModule({
  declarations: [
    EwMaImageComponent,
    ImageLibComponent,
    ListImagesComponent,
    MyImagesComponent,
    UnsplashImagesComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    EwCommonModule,
    EwMaterialComponentsModule,
    NgxPaginationModule,
    TranslateModule.forChild(),
    NgxDropzoneModule,
  ],
  providers: [TranslateStore,EwTranslateService],
  exports: [EwMaImageComponent],
})
export class EwMaImageModule {
  /**
   * @description
   * Ew-ma-schedule module exports
   * @param environment Local or Prod
   * @returns EwMaScheduleModule module
   */
  public static forRoot(environment: any): ModuleWithProviders {
    return {
      ngModule: EwMaImageModule,
      providers: [
        EwMaImageService,
        {
          provide: 'env', // you can also use InjectionToken
          useValue: environment,
        },
      ],
    };
  }
}
